<template>
  <div>
    {{ player.fullName || "" }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestedPlayerId: null,
    };
  },
  props: ["id"],
  computed: {
    player() {
      return this.$store.getters["players/byId"](this.id) || {};
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(playerId) {
        this.ensurePlayerLoaded(playerId);
      },
    },
  },
  methods: {
    ensurePlayerLoaded(playerId) {
      if (playerId == null || playerId === "") return;
      const id = String(playerId);
      if (this.$store.getters["players/byId"](id)) return;
      if (this.requestedPlayerId === id) return;
      this.requestedPlayerId = id;
      this.$store.dispatch("players/fetchById", id).catch(() => {});
    },
  },
};
</script>

<style scoped>
/* 
.card{
  position: inherit;
} */
</style>
